module.exports = __webpack_public_path__ + "static/media/Golden tower 11.e3de418d.webp";